import React from 'react'
import PropTypes from 'prop-types'
import Switch from '../../ui/Switch'

const PANEL_CLASS = 'tw:mt-4 tw:flex tw:flex-wrap tw:items-start tw:justify-between tw:gap-4 '
  + 'tw:rounded-sm tw:bg-gray-50 tw:p-4'

const QuestionSettings = ({ id, mandatory, onMandatoryChange, children = null, aside = null }) => (
  <div className={PANEL_CLASS}>
    <div className="tw:flex tw:flex-col tw:gap-4">
      <Switch
        id={`mandatory-question-${id}`}
        checked={mandatory}
        label="Réponse obligatoire"
        onChange={onMandatoryChange}
      />
      {children}
    </div>
    {aside}
  </div>
)

QuestionSettings.propTypes = {
  aside: PropTypes.node,
  children: PropTypes.node,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  mandatory: PropTypes.bool.isRequired,
  onMandatoryChange: PropTypes.func.isRequired
}

QuestionSettings.defaultProps = {
  aside: null,
  children: null
}

export default QuestionSettings
